"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M10.412 1.589v4.59H4.855c-.77 0-1.394.624-1.394 1.394V14c0 .55.318 1.024.78 1.252v3.429c0 .493.398.753.604.849l2.35 1.098.011.005.063.025v1.653a1.69 1.69 0 0 0 1.689 1.69h5.665a1.69 1.69 0 0 0 1.691-1.69v-1.655a1.81 1.81 0 0 0 .059-.023l.01-.005 2.354-1.091c.204-.096.605-.353.605-.85V15.38A1.394 1.394 0 0 0 20.54 14V7.573c0-.77-.624-1.394-1.394-1.394h-5.557v-4.59a1.588 1.588 0 0 0-3.176 0ZM7.938 7.502h3.401v6.569H7.938v-6.57Zm-1.323 0h-1.76a.071.071 0 0 0-.071.071V14c0 .04.032.071.071.071h1.76v-6.57Zm6.047 6.569h3.427v-6.57h-3.286l-.025.001h-.116v6.569Zm6.483 0h-1.733v-6.57h1.733c.04 0 .072.033.072.072V14a.07.07 0 0 1-.072.071ZM7.952 19.464h7.674a.66.66 0 0 0 .225-.047l2.168-1.006V15.4a.967.967 0 0 0-.098-.005H5.66a.968.968 0 0 0-.097.005v3.005l2.167 1.013a.65.65 0 0 0 .222.046Zm.64 2.847v-1.524h6.4v1.524a.367.367 0 0 1-.368.367H8.958a.366.366 0 0 1-.367-.367Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};